import React from 'react'
import { Button, Col, DatePicker, Input, Row, Select, Space, Tooltip } from 'antd';
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import StaffAttendance from './staffAttendance';
import get from 'lodash/get';
import { exportToExcel } from '../../utilities/pnlSummary';
import { REQUIRED_HEADERS_DAILY } from '../../constants/staffDetailManagement';
import map from 'lodash/map';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from 'dayjs';
import find from "lodash/find"

dayjs.extend(utc);
dayjs.extend(timezone);


const AttendanceTabFilters = ({ staffs, filter, config, getCompanyStaffAttendence, staffAttendence, setStaffAttendence, shift, setShift }) => {

  return (
    <div className={`overflow-y-auto`}>
      <Row className='py-2'>
        <Col xs={24} md={24} className="flex flex-row justify-between mb-2">
          <Space>
            <Tooltip title="Download attandence sample">
              <Button onClick={() => exportToExcel(REQUIRED_HEADERS_DAILY, map(get(staffAttendence, "data"),(item)=>{
                const dist = dayjs.utc(get(staffAttendence,"filters.date")).tz("Asia/Kolkata");

                return {...item, date: dist.format("YYYY-MM-DD")}
              }), {
                "S.N.": "id",
                "Name": "name",
                "Staff EMP_ID": 'emp_id',
                "Date": "date",
                "Shift": "staff_attendance.shift.name",
                "In Time": "staff_attendance.in_time",
                'Out Time': "staff_attendance.out_time"
              }, "daily_attendence.xlsx")} type="primary">
                <DownloadOutlined />
              </Button>
            </Tooltip>
            <StaffAttendance staffs={staffs} title="Import Attandance" updateData={() => getCompanyStaffAttendence(get(staffAttendence, "filters"))} fileType='daily' filter={filter} config={config} />
          </Space>
          <Space>
              <Select options={map(get(filter,"company.company_shifts"),(item)=>{
                return {label: get(item, "name"), value:get(item, "id")}
              })}
              onChange={(value)=>{
                setShift(value)
                setStaffAttendence({
                  ...staffAttendence, 
                  data:get(find(get(staffAttendence, "allShiftAttendence"),['id',value]),'attendance')
                })
              }}
              value={shift}
              placeholder="Select Shift"
              />
            <DatePicker
              allowClear={false}
              format={"DD-MM-YYYY"}
              value={get(staffAttendence, "filters.date")}
              onChange={(value) => {
                const obj = { ...get(staffAttendence, "filter"), date: value }
                getCompanyStaffAttendence(obj)
              }}
            />
            <Input
              style={{
                width: 200,
              }}
              value={get(staffAttendence, "filters.searchQuery")}
              size="middle"
              placeholder="Search staff"
              onChange={(event) => {
                setStaffAttendence({ ...staffAttendence, filters: { ...get(staffAttendence, "filters"), searchQuery: event.target.value } })
              }}
              allowClear
              prefix={<SearchOutlined className="mr-2 text-gray-400" />}
            />
          </Space>
        </Col>
      </Row>
    </div>
  )
}

export default AttendanceTabFilters
